// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1bzkK","log":"ModalInventoryLogs_log__10PaJ","date":"ModalInventoryLogs_date__2NyR7","userName":"ModalInventoryLogs_userName__2i1Xe"};